module.exports = __webpack_public_path__ + "static/media/hot65.a1a44ee2.jpg";